import { Type } from "@angular/core";
import { ArrayHelper } from "../../utilities/contracts/array-helper";
import { StringHelper } from "../../utilities/contracts/string-helper";
import { Dictionary } from "../../utilities/dictionary";
import { Mapper } from "./mapper";
import * as i0 from "@angular/core";
import * as i1 from "./string-to-class.token";
export class AutomapperService {
    constructor(StringToClass) {
        this.StringToClass = StringToClass;
        this.maps = new Dictionary();
    }
    createMap(from, to) {
        StringHelper.throwIsAvailableError(from, "from");
        StringHelper.throwIsAvailableError(to, "to");
        this.throwMissingInDictionaryError(to);
        const key = this.createKey(from, to);
        this.maps.add(key, new Mapper());
        return this.maps.get(key);
    }
    map(from, to, item) {
        const key = this.createKey(from, to);
        const map = this.maps.get(key);
        const mappedProperties = Object
            .keys(map.mappings)
            .reduce(this.assignProperty(map.mappings, item), {});
        const ctor = this.StringToClass.get(to);
        const result = new ctor(mappedProperties);
        return result;
    }
    mapMany(from, to, items) {
        if (!ArrayHelper.isAvailable(items)) {
            return [];
        }
        const results = items.map(item => this.map(from, to, item));
        return results;
    }
    curry(from, to) {
        return (item) => {
            return this.map(from, to, item);
        };
    }
    curryMany(from, to) {
        return (items) => {
            return this.mapMany(from, to, items);
        };
    }
    createKey(from, to) {
        const cleanFrom = StringHelper.clean(from);
        const cleanTo = StringHelper.clean(to);
        const delimeter = "[]";
        const key = `${cleanFrom}${delimeter}${cleanTo}`;
        return key;
    }
    assignProperty(mappings, item) {
        return (newObject, key) => {
            if (mappings.hasOwnProperty(key)) {
                newObject[key] = mappings[key](item);
            }
            return newObject;
        };
    }
    throwMissingInDictionaryError(to) {
        if (!this.StringToClass.has(to)) {
            throw new Error(`The string '${to}' has not been added to the 'StringToClass' dictionary.`);
        }
    }
}
AutomapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AutomapperService_Factory() { return new AutomapperService(i0.ɵɵinject(i1.STRING_TO_CLASS_DICTIONARY)); }, token: AutomapperService, providedIn: "root" });
